import styled, { css } from 'styled-components'
import get from 'lodash/get'

import { useLoading } from 'components/Loading'

export const NavBarContent = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	${useLoading}
`

export const StyledBar = styled.div`${({ subNav, theme, height }) => `
	${/*
		Get height depending of provided 'height' prop in order of priority:
		1. (String) From styled theme.navBarHeight[height] by provided key.
		2. (Number) Use prop 'height' provided as number.
		3. (Undefined) Use default as theme.navBarHeight.default if 'height' isn't provided at all.
	*/''}
	height: ${get(theme, ['navBarHeight', height]) || (height ? height + 'px' : get(theme, 'navBarHeight.default'))};
	border-radius: 3px 3px 0 0;
	background-color: ${theme.primaryColor};
	display: flex;
	${subNav && `
		${StyledNavBarItem} {
			font-size: 12px;
		}
	`}
`}`

export const StyledNavBarItem = styled.div`${({ isDisabled, isClickable, theme, withDropDown }) => `
	position: relative;
	display: flex;
	flex-grow: 1;
	justify-content: center;
	align-items: center;
	text-decoration: none;
	font-size: 14px;
	letter-spacing: 0.01em;
	font-weight: 300;
	color: #fff;
	&:not(:first-of-type):before {
		content: '';
		width: 1px;
		position: absolute;
		top: 20%;
		bottom: 20%;
		left: 0;
		background-color: ${theme.primaryHover};
		opacity: 0.8;
	}
	svg {
		display: block;
		font-size: 22px;
		margin: 5px;
	}

	cursor: ${isDisabled ? 'not-allowed' : isClickable ? 'pointer' : 'auto'};
	&:hover {
		background-color: ${isClickable ? theme.primaryHover : 'none'} !important;
	}
	${/* Hide vertical dividers only on active and hovered links */''}
	${(isClickable && !withDropDown) && css`
		&:hover + *:before {
			display: none;
		}
	`}
	${/* react-router sets className 'active' to link when it is selected */''}
	&.active {
		color: ${theme.activeColor};
		font-weight: 400;
		svg g, svg path {
			fill: ${theme.activeColor};
		}
		&:hover {
			background-color: none;
			cursor: default;
		}
	}
`}`
